import React from 'react';
import PropTypes from 'prop-types';
import Feedback from '../Feedback';
import ProjectFeedback from '../ProjectFeedback';
import './Feedbacks.scss';
function Feedbacks(_ref) {
  var canCreateFeedback = _ref.canCreateFeedback,
    feedbacks = _ref.feedbacks,
    _handleUpdateFeedback = _ref.handleUpdateFeedback,
    csrfToken = _ref.csrfToken,
    emailShareUrl = _ref.emailShareUrl,
    resource = _ref.resource,
    resourceId = _ref.resourceId,
    email = _ref.email;
  if (resource === 'proposal') {
    return /*#__PURE__*/React.createElement("div", {
      className: "feedbacks"
    }, feedbacks.map(function (feedback) {
      return /*#__PURE__*/React.createElement(Feedback, {
        canCreateFeedback: canCreateFeedback,
        key: feedback.email,
        csrfToken: csrfToken,
        emailShareUrl: emailShareUrl,
        resource: resource,
        resourceId: resourceId,
        feedback: feedback
      });
    }));
  }
  var previousEmail;
  var currentEmail;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-feedbacks feedbacks"
  }, feedbacks.map(function (feedback) {
    previousEmail = currentEmail;
    currentEmail = feedback.email;
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(feedback.email, "-").concat(feedback.id),
      className: "grouped-feedbacks"
    }, /*#__PURE__*/React.createElement(ProjectFeedback, {
      key: feedback.id,
      canEdit: canCreateFeedback && email === feedback.email && feedback.most_recent,
      displayName: previousEmail !== currentEmail,
      csrfToken: csrfToken,
      emailShareUrl: emailShareUrl,
      resource: resource,
      resourceId: resourceId,
      feedback: feedback,
      note: feedback.note,
      handleUpdateFeedback: function handleUpdateFeedback(fb, note) {
        return _handleUpdateFeedback(fb, note);
      },
      email: email
    }));
  }));
}
Feedbacks.propTypes = {
  canCreateFeedback: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  emailShareUrl: PropTypes.string,
  handleUpdateFeedback: PropTypes.func,
  email: PropTypes.string
};
Feedbacks.defaultProps = {
  canCreateFeedback: false,
  handleUpdateFeedback: function handleUpdateFeedback() {},
  email: '',
  emailShareUrl: null
};
export default Feedbacks;